import { InfoDocumentComponent } from "../InfoDocumentComponent";
import aboutContent from "./content";

export const AboutComponent = () => <InfoDocumentComponent content={aboutContent} />;
